export default function ScheduleTable({ scheduleData }: { scheduleData: any }) {
	return (
		<div className="overflow-x-auto">
			<table className="w-full table-auto text-sm">
				<thead>
					<tr className="text-left text-gray-600">
						<th className="px-2 py-1 font-medium text-lg">Dag</th>
						<th className="px-2 py-1 font-medium text-lg">Henting</th>
						<th className="px-2 py-1 font-medium text-lg">Levering</th>
					</tr>
				</thead>
				<tbody>
					{scheduleData.map(({ day, pickup, delivery }) => (
						<tr key={day} className="border-gray-100 border-t">
							<td className="px-2 py-2 font-semibold text-gray-800">{day}</td>
							<td className="px-2 py-2 text-gray-700">
								{pickup?.open
									? `${pickup.openingTime} - ${pickup.closingTime}`
									: ""}
							</td>
							<td className="px-2 py-2 text-gray-700">
								{delivery?.open
									? `${delivery.openingTime} - ${delivery.closingTime}`
									: ""}
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
}
